"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFrontendFlags = void 0;
const unleash_proxy_client_1 = require("unleash-proxy-client");
const utils_1 = require("./utils");
/**
 * Create a client-side SDK instance and get evaluated flags from Unleash Proxy or Client API
 * @see clientOptions https://github.com/Unleash/unleash-proxy-client-js#available-options
 */
const getFrontendFlags = async (config) => new Promise((resolve, reject) => {
    const unleash = new unleash_proxy_client_1.UnleashClient({
        ...(0, utils_1.getDefaultClientConfig)(),
        ...(config || {}),
        disableRefresh: true,
        disableMetrics: true,
    });
    unleash.on("ready", () => {
        resolve({ toggles: unleash.getAllToggles() });
        unleash.stop();
    });
    unleash.on("error", (error) => {
        reject(error);
        unleash.stop();
    });
    unleash.start();
});
exports.getFrontendFlags = getFrontendFlags;
